/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  Button,
  Card,
  Checkbox,
  Label,
  TextInput,
  useTheme,
} from "flowbite-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { authService } from "../../services/main";
import toast, { Toaster } from "react-hot-toast";
import { useAuth } from "../../context/AuthContext";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
// Define types for the form data and response
interface LoginForm {
  identifier: string;
  password: string;
}

interface AuthResponse {
  data: { token: string; user: any };
}

const SignInPage: React.FC = () => {
  const [form, setForm] = useState<LoginForm>({ identifier: "", password: "" });
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  // Inside handleLogin function
  const { login } = useAuth();

  const { mode } = useTheme();
  // Handle form field change
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setForm((prevForm) => ({ ...prevForm, [name]: value }));
  };

  // Handle form submission
  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response: AuthResponse = await authService.authenticate(form);

      // Save token in session storage
      sessionStorage.setItem("token", response.data.token);
      sessionStorage.setItem("user", JSON.stringify(response.data.user));
      toast.success("Login successful!");
      login(); // Set the user as authenticated
      // Redirect to the home page
      navigate("/");
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "An unexpected error occurred.";
      toast.error(`Login failed: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  };
  // Handle Google login
  const handleGoogleLogin = async (credentialResponse: any) => {
    const decoded: any = jwtDecode(credentialResponse.credential);
    console.log("Decoded Google User Info:", decoded);

    // Send the Google token to your backend for verification
    try {
      const response: AuthResponse = await authService.authenticate({
        googleToken: credentialResponse.credential,
      });

      // Save token and user info in session storage
      sessionStorage.setItem("token", response.data.token);
      sessionStorage.setItem("user", JSON.stringify(response.data.user));
      toast.success("Login successful!");
      login(); // Set the user as authenticated
      // Redirect to the home page
      navigate("/");
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "An unexpected error occurred.";
      toast.error(`Google login failed: ${errorMessage}`);
    }
  };
  return (
    <div className="flex flex-col h-screen m-auto items-center justify-center px-6 lg:h-screen lg:gap-y-12">
      <Card
        horizontal
        imgSrc="https://img.freepik.com/free-photo/office-workers-using-finance-graphs_23-2150408668.jpg?ga=GA1.1.1506045701.1748711164&semt=ais_hybrid&w=740"
        imgAlt=""
        className="w-full md:max-w-[1024px] md:[&>*]:w-full md:[&>*]:pt-8 [&>img]:hidden md:[&>img]:w-96 md:[&>img]:p-0 lg:[&>img]:block"
      >
        <img src="https://stage.vidzai.com/ops/images/logo.png" alt="Vidzai CRM" width={150} height={150} className="-ml-1" />
        <h1 className="mb-3 text-2xl font-bold dark:text-white md:text-3xl">
          Sign in to platform
        </h1>

        <form onSubmit={handleLogin}>
          <div className="mb-4 flex flex-col gap-y-3">
            <Label htmlFor="identifier">Your email or phone number</Label>
            <TextInput
              id="identifier"
              name="identifier"
              placeholder="Enter email or phone"
              type="text"
              value={form.identifier}
              onChange={handleChange}
              required
            />
          </div>
          <div className="mb-6 flex flex-col gap-y-3">
            <Label htmlFor="password">Your password</Label>
            <TextInput
              id="password"
              name="password"
              placeholder="••••••••"
              type="password"
              value={form.password}
              onChange={handleChange}
              required
            />
          </div>
          <div className="mb-6">
            <button
              type="button"
              onClick={() => navigate("/authentication/forgot-password")}
              className="text-sm text-primary-600 dark:text-primary-300 hover:underline"
            >
              Forgot Password?
            </button>
          </div>
          <div className="mb-6">
            <Button
              type="submit"
              className="w-full lg:w-auto"
              disabled={loading}
            >
              {loading ? "Logging in..." : "Login to your account"}
            </Button>
          </div>
          <hr className="my-6 border-gray-300 w-auto" />
          <div className="mb-6">
            {/* <button
              type="button"
              className="w-full block bg-white hover:bg-gray-100 focus:bg-gray-100 text-gray-900 font-semibold rounded-lg px-4 py-3 border border-gray-300"
            > */}
            {/* <div className="flex items-center justify-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-6 h-6"
                  viewBox="0 0 48 48"
                >
                  <defs>
                    <path id="a" d="M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z" />
                  </defs>
                  <clipPath id="b">
                    <use xlinkHref="#a" overflow="visible" />
                  </clipPath>
                  <path clipPath="url(#b)" fill="#FBBC05" d="M0 37V11l17 13z" />
                  <path clipPath="url(#b)" fill="#EA4335" d="M0 11l17 13 7-6.1L48 14V0H0z" />
                  <path clipPath="url(#b)" fill="#34A853" d="M0 37l30-23 7.9 1L48 0v48H0z" />
                  <path clipPath="url(#b)" fill="#4285F4" d="M48 48L17 24l-4-3 35-10z" />
                </svg>
                <span className="ml-4">Sign in with Google</span>
              </div> */}
            <GoogleOAuthProvider clientId="734558150273-k68q9qj6kfdrjh4h1t6538uvjkm7mu4e.apps.googleusercontent.com">
              <div>
                <GoogleLogin
                  onSuccess={handleGoogleLogin}
                  onError={() => console.log("Login Failed")}
                />
              </div>
            </GoogleOAuthProvider>
            {/* </button> */}
          </div>
        </form>
        <p className="text-sm -mt-6 text-gray-500 dark:text-gray-300">
          Not registered?&nbsp;
          <button
            onClick={() => navigate("/authentication/sign-up")}
            className="text-primary-600 dark:text-primary-300"
          >
            Create account
          </button>
        </p>
      </Card>
    </div>
  );
};

export default SignInPage;
